import { Modal, Button } from 'react-bootstrap';

const ErrorModal = (props) => {
  const { errorMessage, setErrorMessage } = props;

  return (
    <Modal show={errorMessage !== ''} centered>
      <Modal.Body>
          {errorMessage}
      </Modal.Body>
      <Modal.Footer>
          <Button variant="primary" onClick={() => setErrorMessage('')}>
          Rendben
          </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorModal;
